/** Banned enrollment = the enrollment pivot went inactive — the same rule the
 *  classroom provider uses. The profile/classrooms endpoint prefixes its
 *  pivot columns (pivot_active) while classroom/get uses plain names.
 *
 *  Lives outside MyClassrooms.tsx so the home rail can import it without
 *  pulling the lazy-loaded فصولي page into the home chunk.
 */
const pivotActive = (pivot?: { active?: boolean; pivot_active?: boolean }) => (pivot ? pivot.active ?? pivot.pivot_active : undefined)

export const isBannedEnrollment = (cl: Classroom) => {
	const fromEnrollment = pivotActive(cl.enrolled?.[0]?.pivot as { active?: boolean; pivot_active?: boolean } | undefined)
	if (fromEnrollment !== undefined) return !fromEnrollment
	const fromClassroom = pivotActive(cl.pivot as unknown as { active?: boolean; pivot_active?: boolean } | undefined)
	if (fromClassroom !== undefined) return !fromClassroom
	return false
}
